<template>
  <section class="home-banner">
    <!-- <el-carousel height="120px" indicator-position="none" :interval="6000">
      <el-carousel-item v-for="(item, index) in list" :key="index">
        <img :src="item.photoUrl" alt="" @click="handleClick(item)">
        <div class="small" @click="handleClick(item)">{{ item.message }}</div>
      </el-carousel-item>
    </el-carousel> -->
    <!-- <div class="go-search" @click="goSearch()">搜索文件、报告、术语、问答、共享资料等更多内容</div> -->
    <div class="go-search" @click="goSearch()">问问DeepSeek+小智</div>
  </section>
</template>

<script>
// import share from '@/components/share.vue'
import api from '../../../api/index'
export default {
  data () {
    return {
      activeNumber: 0,
      tmier: null,
      bannerList: [],
      remarks240B: ''
    }
  },
  mounted () {
    api.getHotList({
      type: 'carousel'
    }).then(res => {
      if (res.code === 200) {
        this.bannerList = res.data
      }
    })
    api.remarks({
      type: 240
    }).then(res => {
      this.remarks240B = res.data.list[0].sign
    })
  },
  methods: {
    // setTimer () {
    //   !this.timer && (this.timer = setInterval(() => {
    //     this.activeNumber++
    //     if (this.activeNumber >= this.list.length) {
    //       this.activeNumber = 0
    //     }
    //   }, 4500))
    // },
    // handleClick (item) {
    //   console.log(item)
    //   window.open(item.jumpUrl)
    //   // this.$electron.shell.openExternal(item.jumpUrl)
    // },
    goSearch () {
      api.getUserInfo().then(res => {
        if (res.code === 200) {
          if (res.data.ashKetchup === true) {
            this.$router.push('/h5public-search')
          } else {
            var remarks240BConfirm = confirm(this.remarks240B)
            if (remarks240BConfirm) {}
          }
        }
      })
    }
  },
  computed: {
    list () {
      return this.bannerList.slice(0, 5)
    }
  },
  components: {
  }
}
</script>

<style lang="scss">
.home-banner {
  padding: 20px 0 0 0 ;
  bottom: -10%;
  border-radius: 4px;
  overflow: hidden;
  background: #f5f6f7;
  border: 1px solid #efefef;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .small {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .6);
    font-size: 12px;
    color: #fff;
    padding: 4px 6px;
    cursor: pointer;
  }
  .go-search {
    background: #409EFF;
    color: #fff;
    border-radius: 4px;
    margin-left: 12px;
    margin-right: 8px;
    padding: 4px 16px;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
  }
}
</style>
